export enum AttributeHistoryPref {
	ENABLED = 'metadata.history.enabled',
}
